import React, {PureComponent} from 'react'
import {Route, Switch} from 'react-router-dom'
import HeaderBackgroundImage from '../../static/img/default-bg.svg'
import StickyHeader from './StickyHeader'
import WeekSlider from './WeekSlider'
import classNames from 'classnames';
import { getProperty } from '../../helpers/properties';
import {connect} from 'react-redux'
import MegaNav from './MegaNav'
import EnrolmentsHeader from './EnrolmentsHeader'
import EnrolmentsTabs from './EnrolmentsTabs'
import {getConfiguration} from "../../helpers/configuration";

const mapStateToProps = ({page: {slug, title, backgroundImage}}) => {
  return {
    slug,
    title,
    backgroundImage,
  }
}

class Header extends PureComponent {
  render () {
    return (
      <header className={classNames('header', `header-${this.props.slug}`)}
      >
        <div className="header-bg" style={{
          backgroundImage: `url(${this.props.backgroundImage ? this.props.backgroundImage : HeaderBackgroundImage})`
        }}/>

        <StickyHeader onHamburgerClick={this.props.onHamburgerClick}/>

        <Switch>
          <Route path={getConfiguration('baseUrl') + "/enrolments"} render={() => (
            <EnrolmentsHeader title={this.props.title}/>
          )}/>
          <Route render={() => (
            <div className='container heading-container'>
              <div className="heading-container__heading">
                <h1>{this.props.title}</h1>
              </div>
            </div>
          )}/>
        </Switch>

        <Route path={getConfiguration('baseUrl') + '/'} exact={true} component={WeekSlider}/>

        <Route path={getConfiguration('baseUrl') + '/resources'} exact component={MegaNav}/>

        <Route path={getConfiguration('baseUrl') + '/resources/:articleId'} component={MegaNav}/>

        <Route path={getConfiguration('baseUrl') + '/enrolments'} component={EnrolmentsTabs}/>
      </header>
    )
  }
}

export default connect(mapStateToProps)(Header)
